/**
 * BRR Stage Constants and Helpers
 * Defines the linear stage progression for BRR workflow.
 * `currentPage` stores the next page to show (the page after the last completed stage).
 */

/**
 * Ordered array of BRR stages representing the workflow progression.
 * start-brr → document-validation → form → qp-review
 */
export const BRR_STAGES = [
  'start-brr',
  'document-validation',
  'form',
  'qp-review'
] as const;

export type BRRStage = typeof BRR_STAGES[number];

/**
 * Returns the next stage in the BRR workflow sequence.
 * Returns null if the current stage is the last one or not found.
 */
export function getNextStage(current: string): BRRStage | null {
  const index = BRR_STAGES.indexOf(current as BRRStage);
  if (index === -1 || index === BRR_STAGES.length - 1) {
    return null;
  }
  return BRR_STAGES[index + 1];
}

/**
 * Validates whether a stage string is a valid BRR stage that can be resumed.
 * Only stages after start-brr are valid resume points (you wouldn't resume to start-brr).
 */
export function isValidResumeStage(stage: string): stage is BRRStage {
  return BRR_STAGES.includes(stage as BRRStage) && stage !== 'start-brr';
}
